import UserPage from '../../common/UserPage/UserPage';
import Footer from '../../common/Footer/Footer';
import TherapistProfileSettings from '../../components/TherapistProfileSettings/TherapistProfileSettings'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getCurrentTherapist } from '../../redux/therapistSlice'

function TherapistProfilePage() {
  const dispatch = useDispatch();

  const therapistState = useSelector((state) => state.therapist) || {};
  const { therapist} = therapistState;

  useEffect(() => {
    dispatch(getCurrentTherapist());
  }, [dispatch]);

  return (
    <div>
        <UserPage customImage={therapist?.picture} />
        <TherapistProfileSettings />
        <Footer />
    </div>
  )
}

export default TherapistProfilePage